import { Dialog, Transition } from '@headlessui/react';
import { useState } from 'react';
import { Fragment } from 'react';
import QRCode from 'react-qr-code';
import { imageBaseUrl } from '../../config/http';
import { IconCopy, IconCheck } from '@tabler/icons-react';
import { PhotoView } from 'react-photo-view';
import ImageComponent from '../../utils/ImageComponent';
import { IconX } from '@tabler/icons-react';

export default function DetailItem({ closeModalDetail, openDetail, detailItem }) {
  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function openLah() {
    closeModalDetail();
    setOpenInput(false);
  }
  const [openInput, setOpenInput] = useState(false);
  const [openImage, setOpenImage] = useState(false);
  const [openImage2, setOpenImage2] = useState(false);
  const [openImage3, setOpenImage3] = useState(false);
  const [load, setLoad] = useState(false);
  const [copy, setCopy] = useState(false);

  const handleCopy = (kodeItem) => {
    navigator.clipboard.writeText(kodeItem);
    setCopy(true);
    setTimeout(() => {
      setCopy(false);
    }, 3000);
  };

  return (
    <>
      <Transition appear show={openDetail} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => { }}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
          </Transition.Child>
          {/* {openImage && (
            <div className="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700/20  flex flex-col items-center justify-center">
              <div
                onClick={() => setOpenImage(false)}
                className={'absolute top-52 right-7 lg:top-16 lg:right-[280px] md:right-[120px] md:top-28 '}
              >
                <div className="bg-white p-2 rounded-full cursor-pointer hover:bg-white/50">
                  <IconX />
                </div>
              </div>
              <div>
                {!load && (
                  <div className="max-w-[48px] max-h-[48px]  rounded-full animate-spin border-4 border-dashed border-green-500 border-t-transparent"></div>
                )}
                <img
                  onLoad={() => setLoad(true)}
                  width={''}
                  className={'lg:w-[700px] md:w-[500px] w-[350px] scale-50'}
                  height={''}
                  src={detailItem?.gambar === null ? '' : `${imageBaseUrl}${detailItem?.gambar[0]?.asli}`}
                />
              </div>
            </div>
          )} */}
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex items-center justify-center p-4 min-h-[440px]">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden bg-white dark:bg-slate-900 px-5 sm:px-6 pt-12 sm:pt-6 pb-5 text-left align-middle shadow-xl transition-all sm:rounded-xl relative">
                  {/* Absolute Close Button for better accessibility */}
                  <button
                    onClick={openLah}
                    className="absolute top-3 right-3 p-2 rounded-full text-slate-400 hover:text-red-500 hover:bg-red-50 dark:hover:text-red-400 dark:hover:bg-red-900/20 transition-all z-10"
                    title="Tutup"
                  >
                    <IconX size={24} stroke={2.5} />
                  </button>

                  {/* Header Section */}
                  <div className="flex flex-col sm:flex-row items-start justify-between border-b border-amber-100/60 dark:border-slate-800 pb-4 mb-5 gap-4">
                    <div className="flex-1 w-full min-w-0">
                      <div className="flex gap-3 items-center font-bold text-xl sm:text-2xl text-slate-800 dark:text-white mb-2 pr-10 sm:pr-0">
                        {detailItem?.jenis_kategori?.nama_jenis}
                      </div>
                      <div className="flex flex-wrap items-center gap-2 mb-1.5">
                        <span className="text-[10px] sm:text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">KODE BARANG:</span>
                        <div className="flex items-center gap-1.5 bg-amber-50 dark:bg-amber-900/20 px-2 py-0.5 rounded border border-amber-200 dark:border-amber-800/50">
                          <span className="text-sm font-bold text-amber-600 dark:text-amber-400">
                            {detailItem?.kode_item}
                          </span>
                          {copy ? (
                            <IconCheck className="w-4 h-4 text-green-500 stroke-2" />
                          ) : (
                            <button onClick={() => handleCopy(detailItem?.kode_item)} className="text-slate-400 hover:text-amber-500 transition-colors">
                              <IconCopy className="w-4 h-4 stroke-1.5" />
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="text-slate-400 dark:text-slate-500 text-[10px] sm:text-xs">
                        Ditambahkan pada: {detailItem?.created_at}
                      </div>
                    </div>
                    <div className="flex items-center gap-3 shrink-0 self-end sm:self-start">
                      {/* QR Code */}
                      <div className="text-center bg-white p-1.5 rounded-lg border border-slate-200 shadow-sm">
                        <QRCode
                          value={detailItem?.kode_item === undefined ? 'unkwow' : detailItem?.kode_item}
                          size={56}
                        />
                      </div>
                      {/* Lampiran Gambar */}
                      {detailItem?.gambar1?.[0]?.asli ? (
                        <div className="relative group rounded-lg overflow-hidden border-2 border-amber-200 dark:border-amber-700/50 bg-white dark:bg-slate-900 shadow-sm transition-all hover:border-amber-400 hover:shadow-md cursor-zoom-in">
                          {openDetail && (
                            <PhotoView src={`${imageBaseUrl}${detailItem?.gambar1[0]?.asli}`}>
                              <img
                                className="w-[56px] h-[56px] sm:w-[64px] sm:h-[64px] object-cover opacity-90 group-hover:opacity-100 transition-opacity"
                                src={`${imageBaseUrl}${detailItem?.gambar1[0]?.asli}`}
                                alt="Foto Barang"
                              />
                            </PhotoView>
                          )}
                        </div>
                      ) : (
                        <div className="w-[56px] h-[56px] rounded-lg border border-dashed border-slate-300 dark:border-slate-600 bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400 text-[9px] text-center px-1">
                          No Image
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Details Section */}
                  <div className="space-y-4">
                    <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-200/60 dark:border-slate-700/60 overflow-hidden">
                      <div className="px-4 py-3 border-b border-slate-200/60 dark:border-slate-700/60 bg-white/50 dark:bg-slate-800/80">
                        <h2 className="font-semibold text-slate-700 dark:text-slate-200 flex items-center gap-2">
                          <span className="w-1.5 h-4 bg-amber-500 rounded-full"></span>
                          Rincian Barang
                        </h2>
                      </div>
                      <div className="divide-y divide-slate-200/60 dark:divide-slate-700/60">
                        <div className="px-4 py-3 flex text-sm items-center justify-between hover:bg-white/40 dark:hover:bg-slate-800/40 transition-colors">
                          <span className="text-slate-500 dark:text-slate-400 font-medium">Berat</span>
                          <span className="font-bold text-amber-600 dark:text-amber-400 text-base">{detailItem?.berat} <span className="text-sm font-semibold ml-0.5">Gram</span></span>
                        </div>

                      <div className="px-4 py-3 flex text-sm items-center justify-between hover:bg-white/40 dark:hover:bg-slate-800/40 transition-colors">
                        <span className="text-slate-500 dark:text-slate-400 font-medium">Kadar Emas</span>
                        <span className="font-bold text-amber-600 dark:text-amber-400 text-base">{detailItem?.karat} <span className="text-sm font-semibold ml-0.5">Karat</span></span>
                      </div>

                      <div className="px-4 py-3 flex text-sm items-center justify-between hover:bg-white/40 dark:hover:bg-slate-800/40 transition-colors">
                        <span className="text-slate-500 dark:text-slate-400 font-medium">Harga Modal / gr</span>
                        <span className="font-bold text-slate-800 dark:text-slate-200">Rp {numberWithCommas(detailItem?.harga_modal === undefined ? '0' : detailItem?.harga_modal)}</span>
                      </div>

                      <div className="px-4 py-3 flex text-sm items-center justify-between hover:bg-white/40 dark:hover:bg-slate-800/40 transition-colors">
                        <span className="text-slate-500 dark:text-slate-400 font-medium">Lokasi Saat Ini</span>
                        <span className="font-semibold text-slate-700 dark:text-slate-300 bg-slate-200/50 dark:bg-slate-700/50 px-2.5 py-1 rounded border border-slate-300/50 dark:border-slate-600">
                          {detailItem?.cabang?.nama_cabang}
                        </span>
                      </div>

                      <div className="px-4 py-3 flex text-sm items-center justify-between hover:bg-white/40 dark:hover:bg-slate-800/40 transition-colors">
                        <span className="text-slate-500 dark:text-slate-400 font-medium">Status</span>
                        {detailItem?.is_ready === true ? (
                          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded bg-green-50 dark:bg-green-900/20 text-green-600 dark:text-green-400 font-semibold border border-green-200 dark:border-green-800/30">
                            <span className="w-1.5 h-1.5 rounded-full bg-green-500"></span>
                            Tersedia
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 font-semibold border border-red-200 dark:border-red-800/30">
                            <span className="w-1.5 h-1.5 rounded-full bg-red-500"></span>
                            Tidak Tersedia
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                    {/* Transfer History Table */}
                    {!detailItem?.history_transfer?.length ? '' : (
                      <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-200/60 dark:border-slate-700/60 overflow-hidden mt-4">
                        <div className="px-4 py-3 border-b border-slate-200/60 dark:border-slate-700/60 bg-white/50 dark:bg-slate-800/80">
                          <h2 className="font-semibold text-slate-700 dark:text-slate-200 flex items-center gap-2">
                            <span className="w-1.5 h-4 bg-slate-400 dark:bg-slate-500 rounded-full"></span>
                            Riwayat Transfer Lokasi
                          </h2>
                        </div>

                        <div className="overflow-x-auto">
                          <table className="w-full text-sm text-left text-slate-600 dark:text-slate-300">
                            <thead className="text-xs text-slate-500 dark:text-slate-400 uppercase bg-slate-100/50 dark:bg-slate-800/60 border-b border-slate-200/60 dark:border-slate-700/60">
                              <tr>
                                <th scope="col" className="px-4 py-2.5 font-semibold text-center w-12">No</th>
                                <th scope="col" className="px-4 py-2.5 font-semibold">Toko Asal</th>
                                <th scope="col" className="px-4 py-2.5 font-semibold">Toko Tujuan</th>
                                <th scope="col" className="px-4 py-2.5 font-semibold text-right">Tanggal Pindah</th>
                              </tr>
                            </thead>
                            <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                              {detailItem?.history_transfer?.map((ht, i) => (
                                <tr key={i} className="hover:bg-white/60 dark:hover:bg-slate-800/40 transition-colors">
                                  <td className="px-4 py-2.5 text-center text-slate-400 dark:text-slate-500">{i + 1}.</td>
                                  <td className="px-4 py-2.5 font-medium">{ht.asal_cabang.nama_cabang}</td>
                                  <td className="px-4 py-2.5 font-medium text-amber-700 dark:text-amber-400">{ht.tujuan_cabang.nama_cabang}</td>
                                  <td className="px-4 py-2.5 text-right text-slate-500 dark:text-slate-400">{ht.created_at}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                      {/* <div className="border-b mt-1 text-base font-normal text-slate-600 flex justify-between px-5">
                        Histori Barang
                        <div className="text-gray-900">
                          <div className="rounded-sm text-green-500 pb-2">
                            {detailItem?.history_transfer?.map((ht, i) => (
                              <div key={i}>
                                <div className="flex items-center justify-between">
                                  <div>Asal Cabang :</div>
                                  <div>{ht.asal_cabang.nama_cabang}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div> */}
                    <div className="bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-200/60 dark:border-slate-700/60 p-4 mt-4">
                      {detailItem?.keterangan && (
                        <div>
                          <h3 className="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider mb-1.5 flex items-center gap-1.5">
                            Keterangan
                          </h3>
                          <p className="text-sm text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 p-3 rounded-lg leading-relaxed">
                            {detailItem?.keterangan}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="mt-6 flex items-center justify-end">
                    <button
                      type="button"
                      onClick={openLah}
                      className="px-6 py-2.5 rounded-lg font-semibold text-slate-700 dark:text-slate-200 bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 active:bg-slate-300 transition-colors shadow-sm"
                    >
                      Tutup
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
